<template>
  <!-- popup (s) -->
  <div class="popWrap nowOpen">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full hasBtn" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1">상품문의</h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <div class="formArea">
                  <span class="label">
                    내용
                    <span class="required"><span class="blind">필수</span></span>
                  </span>
                  <div class="iptWrap">
                    <textarea class="ipt" title="내용 입력" v-model="contents" placeholder="최소 10자 이상 입력해주세요."></textarea>
                    <!-- 기획서에도 최소 글자인 10자만 표시 되어있음. 최대 글자수 확인 필요.
                    <div class="numByte"><span class="val">0</span> / 5,000</div> -->
                  </div>

                  <span class="label">휴대폰번호</span>
                  <input type="tel" id="phone_2" class="ipt" title="휴대폰번호 입력" placeholder="' - ' 없이 입력해주세요." v-model="cellNum" />
                  <!-- <p class="txtList_star">휴대폰 번호 입력 시, 답변 알림을 드립니다.</p> -->
                  <!--<span class="singleIpt">
                    <input type="checkbox" class="ipt notDel uiAct" name="chk" id="chk_1" v-model="hiddenYn" />
                    <label for="chk_1">비밀글로 문의하기</label>
                  </span> -->

                  <ul class="txtList_star bdTop mt30">
                    <li>주민등록번호, 연락처 등의 타인에게 노출될 경우 개인정보 도용의 위험이 있으니 주의해 주시기 바랍니다.</li>
                    <li>비방, 광고, 불건전한 내용의 글은 관리자에 의해 사전 동의 없이 삭제될 수 있습니다.</li>
                  </ul>
                </div>
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" v-text="btnMsg" @click="insertProdQna" :disabled="btnDisabled"></button>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
    <MessagePop v-if="messagePop" @close="messagePop = false">
      <p v-html="msg"></p>
    </MessagePop>
    <MessagePop v-if="messagePop2" @close="popupClose">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- popup (e) -->
</template>

<script>
import MessagePop from '@/components/popup/MessagePop';
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import { INPUT_CONTENTS, PRODQNA_INSERT_COMPLETE, PRODQNA_UPDATE_COMPLETE } from '@/store/message.type.js';
import { isEmpty } from '@/common/common.function';

export default {
  name: 'productHistory',
  components: {
    MessagePop,
  },
  props: ['propsProdQna'],
  mounted() {
    if (JwtService.getUserInfo()) this.cellNum = JwtService.getUserInfo().phone;

    if (this.propsProdQna.qna.qnaId) {
      this.contents = this.propsProdQna.qna.contents;
      this.cellNum = this.propsProdQna.qna.cellNum;
      this.hiddenYn = true; //this.propsProdQna.qna.hiddenQna;
      this.btnMsg = '수정';
    }
  },
  watch: {
    contents() {
      if (this.contents.length < 10) {
        this.btnDisabled = true;
      } else {
        this.btnDisabled = false;
      }
    },
  },
  data: function() {
    return {
      contents: null,
      cellNum: null,
      hiddenYn: true,

      msg: null,
      messagePop: null,
      messagePop2: null,
      btnMsg: '등록',

      btnDisabled: true,
    };
  },
  methods: {
    insertProdQna: function() {
      if (isEmpty(this.contents)) {
        this.msg = INPUT_CONTENTS;
        this.messagePop = true;
        return false;
      }
      if (this.contents.length < 10) {
        this.msg = '최소 10자 이상 입력해주세요.';
        this.messagePop = true;
        return false;
      }
      // if (isEmpty(this.cellNum)) {
      //   this.msg = '휴대폰번호를 입력해주세요.';
      //   this.messagePop = true;
      //   return false;
      // }

      let paramObj = new Object();
      let request = new Object();

      request.mainType = 'QNT10005';
      request.subType = 'QNT20011';

      this.msg = PRODQNA_INSERT_COMPLETE;

      let url = '/user/auth/qna';
      request.productCode = this.propsProdQna.productInfo.product.productCode;
      request.orderId = this.propsProdQna.productInfo.orderId;
      if (!isEmpty(this.propsProdQna.qna.qnaId)) {
        request.productCode = this.propsProdQna.qna.prodCode;
        request.qnaId = this.propsProdQna.qna.qnaId;
        this.msg = PRODQNA_UPDATE_COMPLETE;
        url = '/user/auth/qna/modify';
      }

      request.contents = this.contents;
      request.cellNum = this.cellNum;
      request.hiddenYn = true; //this.hiddenYn;

      paramObj.request = request;
      paramObj.serviceType = 'app';

      let contentType = new Object();
      contentType.headers = { 'Content-Type': 'multipart/form-data' };

      let formData = new FormData();
      formData.append('param', JSON.stringify(paramObj));

      ApiService.service('POST', url, formData, contentType)
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.messagePop2 = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    popupClose: function() {
      this.messagePop2 = false;
      this.$emit('close');
    },
  },
};
</script>
